module.exports = __webpack_public_path__ + "media/images/icons/flags/PE-c61cb4a8f1a9c5b6f3df7fd1bb67fa7b.svg";